const SECTIONS = {
  overview: { slug: 'overview', name: 'Overview', icon: 'align-left' },
  verdicts: { slug: 'user-verdicts', name: 'User verdicts', icon: 'camcorder' },
  screenshots: { slug: 'screenshots', name: 'Video & Screenshots', icon: 'images' },
  pricing: { slug: 'pricing', name: 'Pricing', icon: 'usd-circle' },
  reviews: { slug: 'reviews', name: 'User reviews', icon: 'star' },
  features: { slug: 'features', name: 'Key features', icon: 'shapes' },
  integrations: { slug: 'integrations', name: 'Integrations', icon: 'layer-group' },
  alternatives: { slug: 'alternatives', name: 'Alternatives', icon: 'chart-network' },
}
const userVerdictNavSection = { id: 'user_verdicts', name: 'User verdicts', icon: 'camcorder', visible: true }

let NAV_SECTIONS = {
  overview: { id: 'overview', name: 'Overview', icon: 'align-left', visible: true, disabled: true },
  screenshots: { id: 'screenshots', name: 'Screenshots', icon: 'images', visible: true },
  pricing: { id: 'pricing', name: 'Pricing', icon: 'usd-circle', visible: true },
  reviews: { id: 'reviews', name: 'User reviews', icon: 'star', visible: true },
  features: { id: 'features', name: 'Key features', icon: 'shapes', visible: true },
  integrations: { id: 'integrations', name: 'Integrations', icon: 'layer-group', visible: true },
  alternatives: { id: 'alternatives', name: 'Alternatives', icon: 'chart-network', visible: true, disabled: true },
}

const generateNavsForUserVerdicts = shouldRenderUserVerdicts =>
  shouldRenderUserVerdicts
    ? // @ts-ignore
      { overview: NAV_SECTIONS.overview, verdicts: userVerdictNavSection, ...NAV_SECTIONS }
    : NAV_SECTIONS

export { NAV_SECTIONS, SECTIONS, generateNavsForUserVerdicts }
